
import Vue from "vue";
import API from "@/api/API";
import store from "@/store";
import {
  requiredRule,
  minLengthRule,
  maxLengthRule,
} from "@/services/helpers/validation-rules";

export default Vue.extend({
  name: "Edit",

  data: () => ({
    model: {} as any,
    studyProgram: [] as Array<any>,
    disableSave: true as boolean,
    fullLoaded: false as boolean,
    errorMessages: {} as any,
  }),

  watch: {
    model: {
      deep: true,
      handler() {
        if (this.fullLoaded) {
          this.disableSave = false;
        }
      },
    },
  },

  computed: {
    computedRules(): object {
      return {
        min: minLengthRule.bind(this),
        max: maxLengthRule.bind(this),
        required: requiredRule.bind(this),
      };
    },
  },

  async beforeRouteEnter(to, from, next) {
    try {
      const item = await API.specialities().getForEdit(Number(to.params.id));
      const studyProgram = await API.studyPrograms().getList();

      next((vm) => {
        vm.model = item;
        vm.setServerResponse(studyProgram);
        vm.$nextTick(() => {
          vm.fullLoaded = true;
        });
      });
    } catch (e) {
      await store.dispatch("alert/showError", e.message);
    }
  },

  methods: {
    setServerResponse(items: any) {
      this.studyProgram = items;
    },
    async submit(): Promise<void> {
      try {
        if ((this.$refs.form as any).validate()) {
          await this.$API
            .specialities()
            .edit(this.$route.params.id as any, this.model);
          await this.$router.push("/specialities");
          await this.$store.dispatch(
            "alert/showSuccess",
            this.$t("global-alert.successful_edit")
          );
        }
      } catch (e) {
        if (e.hasOwnProperty("errors")) {
          this.errorMessages = e.errors;
          setTimeout(() => {
            this.errorMessages = {};
          }, 2000);
        }
        await this.$store.dispatch("alert/showError", e.message);
      }
    },
  },
});
